/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import ButtonMain from "./ButtonMain";
import Icon from "./Icon";
import FooterV3 from "./FooterV3";

const Main = () => {
  return (
    <div className="h-screen bg-[#211F1F]">
      <section class="bg-[#211F1F]">
        <div class="lg:grid lg:min-h-screen lg:grid-cols-12">
          <aside class="relative block h-60 lg:order-last lg:col-span-5 lg:h-full xl:col-span-6">
            <img
              alt="Pattern"
              src="https://ik.imagekit.io/is20rnl48/TM-11%201%20(1).png?updatedAt=1694109318456"
              class="absolute inset-0 h-full w-full object-cover"
            />
          </aside>

          <main class="flex items-center justify-center px-8 py-8 sm:px-12 lg:col-span-7 lg:px-16 lg:py-12 xl:col-span-6">
            <div class="max-w-xl lg:max-w-3xl">
              <a class="block text-white text-xl play" href="https://studio3-referral.vercel.app/">
                <span class="sr-only">Home</span>
                STUDIO3
              </a>

              <h1 class="mt-6 text-[#d4fe42] text-6xl md:text-8xl play uppercase">
                Get 10 for $10.
              </h1>

              <p class="mt-4 leading-relaxed text-gray-100 visby-medium">
                Make sure to purchase your 10 classes for $10 before they run
                out! This offer is only available for a limited time only.
              </p>
              <Icon />
              <ButtonMain class="text-black" />
              <FooterV3 />
            </div>
          </main>
        </div>
      </section>
    </div>
  );
};

export default Main;
